
























































































































































































































































































































































































































































import {
  Component, Mixins, Prop, Watch,
} from 'vue-property-decorator';
import PlatformsAndSuppliersMixin from '@/mixins/PlatformsAndSuppliersMixin';
import {
  groupBy, sumBy, meanBy, uniqBy,
} from 'lodash';
import DateRange from '@/components/common/DateRange.vue';
import {
  accountingSheet,
  accountingSheetCalculatedOperationsUseMart,
  accountingSheetFormationUseStarter,
  accountingSheetWriteThroughUseWorkCalc,
  reportStream,
} from '@/utils/config';
import Axios from 'axios';
import { parseReportResponse } from '@/utils/reportResponse';
import formatReportFreshness from '@/utils/formatReportFreshness';
import { TypeExtractionRules } from '@/classes/schema-constructors/types';
import { getPreviousFullMonthRange } from '@/utils/previousMonthRange';
import { parseAccountingSheetPostError } from '@/utils/parseAccountingSheetPostError';
import { isFormationPollTerminalApiError } from '@/utils/isFormationPollTerminalApiError';
import {
  buildFormationStartBody,
  clientsWithUnsavedRows,
  decimal2,
  formationStatesFromStartResponse,
  platformIdOfOperation,
} from '@/utils/formationStarter';
import type {
  FormationStatusApiResponse,
  FormationStatusState,
} from '@/types/formationStatus';

const ACCOUNTING_SHEET_CALC_DEFAULT_STATUS_CODES = 'supplier_confirmed_fact';

const FORMATION_POLL_INTERVAL_MS = 10_000;
const FORMATION_POLL_REQUEST_TIMEOUT_MS = 30_000;

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    DateRange,
  },
})
export default class FormationOfAccountingSheets extends Mixins(PlatformsAndSuppliersMixin) {
  @Prop({
    type: String,
    required: false,
    default: 'FormationOfAccountingSheets',
  }) readonly localStoragePrefix!: string;

  dates: string[] = [];

  defaultDates: string[] = [];

  openPanels: number[] = [];

  formingPlatformIds: Record<string, boolean> = {};

  formationStatusByPlatform: Record<string, FormationStatusState[]> = {};

  formationPollActive: Record<string, boolean> = {};

  formationPollTimeoutId: Record<string, number> = {};

  formationPollCancelSource: Record<string, { cancel: (message?: string) => void } | null> = {};

  groupOperationsByClients: any = null;

  isOperationsLoading = false;

  reportFreshness = '';

  /** Raw server watermark for recomputing relative "назад" without polling. */
  _reportFreshnessWatermark = '';

  _reportFreshnessInterval: number | null = null;

  settingDefaultsInProgress = false;

  selectedSupplier: string[] = [];

  defaultSupplier: string[] = [];

  selectedClient: string[] = [];

  defaultClient: string[] = [];

  /** Выбранные платформы (мультиселект); одна платформа — массив из одного id. */
  selectedPlatform: string[] = [];

  defaultPlatform: string[] = [];

  operations: any[] = [];

  /** Таблица обновляется только после нажатия «Применить фильтры». */
  filtersWereApplied = false;

  /** Подсветка полей после «Применить» при незаполненных фильтрах. */
  filterApplyErrors = {
    dates: false,
    platform: false,
    supplier: false,
    client: false,
  };

  /** Не реагировать на собственные replace и на программную подстановку из query. */
  _formationSkipQuerySync = false;

  _formationSyncingFromRoute = false;

  /** Подавить sync URL при сбросе/восстановлении поставщиков и клиентов из query. */
  _formationHydratingLists = false;

  /** Подавить рекурсию sync при правке выбора внутри sanitizeFormationQueryParams. */
  _formationSanitizingQuery = false;

  _lastUserPlatformsLen = 0;

  tableHeaders = [
    {
      text: 'Платформа',
      value: 'platformName',
    }, {
      text: 'Поставщик',
      value: 'supplierName',
    }, {
      text: 'Операция',
      value: 'operationName',
    }, {
      text: 'Центр затрат',
      value: 'costCenter',
    }, {
      text: 'Производительные часы',
      value: 'performanceWatch',
    }, {
      text: 'Непроизводительные часы',
      value: 'unproductiveWatch',
    }, {
      text: 'Стоимость часа',
      value: 'costPerHour',
    }, {
      text: 'Выполненный объем',
      value: 'sumActualSize',
    }, {
      text: 'Стоимость короба',
      value: 'boxCost',
    }, {
      text: 'Производительность %',
      value: 'meanPerformance',
    }, {
      text: 'Качество %',
      value: 'meanQuality',
    }, {
      text: 'Итого',
      value: 'totalAmount',
    },
  ];

  mounted() {
    this.calculateDefaultDates();
    this.syncDefaultPlatformForFilters();
    this.$nextTick(() => this.syncFormationQueryParams());
  }

  beforeDestroy() {
    this.stopAllFormationPolls();
    this.clearReportFreshnessTicker();
  }

  beforeRouteLeave(_to: unknown, _from: unknown, next: () => void) {
    this.stopAllFormationPolls();
    next();
  }

  /** Одна доступная платформа — дефолт для сброса `[id]`; несколько — `[]`. */
  syncDefaultPlatformForFilters() {
    this.defaultPlatform = this.userPlatforms.length === 1
      ? [String(this.userPlatforms[0].id)]
      : [];
  }

  initializePlatformFromUserAndStorage() {
    const raw = this.$route.query.platform;
    const qp = raw !== undefined && raw !== null && String(raw).length > 0
      ? String(Array.isArray(raw) ? raw[0] : raw)
      : '';
    if (qp && !this.userPlatforms.length) {
      return;
    }
    if (qp) {
      const want = qp.split(',').map((x) => x.trim()).filter(Boolean);
      const allowed = want.filter((id) => this.userPlatformIds.some((x) => String(x) === id));
      if (allowed.length) {
        this.selectedPlatform = allowed;
      } else {
        this.selectedPlatform = [];
      }
      return;
    }
    if (this.userPlatforms.length === 1) {
      this.selectedPlatform = [String(this.userPlatforms[0].id)];
    } else {
      this.selectedPlatform = [];
    }
  }

  calculateDefaultDates() {
    this.defaultDates = getPreviousFullMonthRange();
  }

  get canSelectAllSuppliers(): boolean {
    return this.hasSelectedPlatforms
      && !this.isOperationsLoading
      && !this.suppliersIsLoading
      && Array.isArray(this.suppliers)
      && this.suppliers.length > 0;
  }

  get canSelectAllClients(): boolean {
    return this.hasSelectedPlatforms
      && !this.isOperationsLoading
      && !this.clientsIsLoading
      && Array.isArray(this.clients)
      && this.clients.length > 0;
  }

  /**
   * Платформы для секций «Создать» — как в `userPlatforms`, только если по операциям
   * есть хотя бы один поставщик (без пустых карточек для выбранных, но «молчаливых» платформ).
   *
   * Площадка с результатом формирования остаётся в списке, даже когда поставщиков в операциях
   * уже нет: иначе карточка исчезает вместе с «Лист учёта №N создан» ровно в тот момент, когда
   * операции ушли из расчёта, и пользователь не успевает увидеть, чем кончилось формирование.
   * Список чистит «Применить фильтры» — он же сбрасывает `formationStatusByPlatform`.
   */
  get platformsForCreateSectionIds(): string[] {
    const ids = this.getSelectedPlatformIds();
    const order = new Map(this.userPlatforms.map((p: { id: string | number }, i: number) => [String(p.id), i]));
    const sorted = [...ids].sort((a, b) => (order.get(a) ?? 999) - (order.get(b) ?? 999));
    return sorted.filter((pid) => this.listOfSuppliersFromOperationsForPlatform(pid).length > 0
      || this.formationStatesForPlatform(pid).length > 0);
  }

  /** Есть ли ещё что формировать по площадке — список поставщиков и кнопка живут по этому признаку. */
  hasSuppliersToShape(platformId: string): boolean {
    return this.listOfSuppliersFromOperationsForPlatform(platformId).length > 0;
  }

  platformLabel(platformId: string): string {
    const row = this.userPlatforms.find((p: { id: string | number }) => String(p.id) === String(platformId));
    return (row as { name?: string })?.name ?? platformId;
  }

  operationPlatformId(operation: any): string {
    return platformIdOfOperation(operation);
  }

  listOfSuppliersFromOperationsForPlatform(platformId: string) {
    const ops = this.operations.filter((o: any) => this.operationPlatformId(o) === String(platformId));
    const result = uniqBy(ops, 'application.Supplier.id')
      .map((i: any) => ({
        id: i.application.Supplier.id,
        legal_name: i.application.Supplier.legal_name,
        total: 0,
      }));

    ops.forEach((operation: any) => {
      result.forEach((item: any) => {
        if (item.id === operation.application.Supplier.id) {
          item.total += operation.total;
        }
      });
    });

    return result;
  }

  listOfClientsFromOperationsForPlatform(platformId: string) {
    const ops = this.operations.filter((o: any) => this.operationPlatformId(o) === String(platformId));
    const result = uniqBy(ops, 'application.client.id')
      .map((i: any) => ({
        id: i.application.client.id,
        legal_name: i.application.client.legal_name,
        total: 0,
      }));

    ops.forEach((operation: any) => {
      result.forEach((item: any) => {
        if (item.id === operation.application.client.id) {
          item.total += operation.total;
        }
      });
    });

    return result;
  }

  selectAllSuppliers() {
    if (!this.canSelectAllSuppliers) {
      return;
    }
    this.selectedSupplier = this.suppliers.map((s: { id: string | number }) => String(s.id));
  }

  selectAllClients() {
    if (!this.canSelectAllClients) {
      return;
    }
    this.selectedClient = this.clients.map((c: { id: string | number }) => String(c.id));
  }

  hasAllSuppliersSelected(): boolean {
    if (!this.suppliers?.length || !this.selectedSupplier?.length) {
      return false;
    }
    if (this.selectedSupplier.length !== this.suppliers.length) {
      return false;
    }
    const set = new Set(this.selectedSupplier.map(String));
    return this.suppliers.every((s: { id: string | number }) => set.has(String(s.id)));
  }

  hasAllClientsSelected(): boolean {
    if (!this.clients?.length || !this.selectedClient?.length) {
      return false;
    }
    if (this.selectedClient.length !== this.clients.length) {
      return false;
    }
    const set = new Set(this.selectedClient.map(String));
    return this.clients.every((c: { id: string | number }) => set.has(String(c.id)));
  }

  encodedSupplierQuery(): string | undefined {
    if (!this.selectedSupplier?.length) {
      return undefined;
    }
    if (this.hasAllSuppliersSelected()) {
      return 'all';
    }
    return this.selectedSupplier.join(',');
  }

  encodedClientQuery(): string | undefined {
    if (!this.selectedClient?.length) {
      return undefined;
    }
    if (this.hasAllClientsSelected()) {
      return 'all';
    }
    return this.selectedClient.join(',');
  }

  formationQueryParamNorm(v: unknown): string {
    if (v === undefined || v === null) {
      return '';
    }
    const s = Array.isArray(v) ? v[0] : v;
    return s === undefined || s === null ? '' : String(s);
  }

  formationFilterQueryMatchesRoute(next: Record<string, unknown>): boolean {
    const keys = ['dateFrom', 'dateTo', 'platform', 'supplier', 'client'] as const;
    return keys.every((k) => this.formationQueryParamNorm(next[k])
      === this.formationQueryParamNorm(this.$route.query[k]));
  }

  /**
   * Убрать из query платформу/поставщиков/клиентов, недоступные пользователю или не из текущих списков.
   * Списки поставщиков/клиентов приходят с бэка в контексте платформы — лишние id из URL отбрасываем.
   */
  sanitizeFormationQueryParams(next: Record<string, unknown>) {
    const p = this.formationQueryParamNorm(next.platform);
    if (p && this.userPlatforms?.length) {
      const parts = p.split(',').map((x) => x.trim()).filter(Boolean);
      const allowed = parts.filter((id) => this.userPlatformIds.some((x) => String(x) === id));
      if (allowed.length === 0) {
        delete next.platform;
        this.selectedPlatform = [];
      } else if (allowed.join(',') !== p) {
        next.platform = allowed.join(',');
        this.selectedPlatform = allowed;
      }
    }

    if (this.userPlatforms?.length && this.getSelectedPlatformIds().length) {
      const allowedSet = new Set(this.userPlatformIds.map(String));
      const kept = this.getSelectedPlatformIds().filter((id) => allowedSet.has(id));
      if (kept.length !== this.getSelectedPlatformIds().length) {
        this.selectedPlatform = kept;
        if (kept.length) {
          next.platform = kept.join(',');
        } else {
          delete next.platform;
        }
      }
    }

    if (!this.hasSelectedPlatforms) {
      return;
    }

    const sup = this.formationQueryParamNorm(next.supplier);
    if (sup && !this.suppliersIsLoading) {
      if (sup === 'all') {
        if (!this.suppliers?.length && !this.clientsIsLoading) {
          delete next.supplier;
          this.selectedSupplier = [];
        }
      } else if (this.suppliers?.length) {
        const allowed = new Set(this.suppliers.map((s: { id: string | number }) => String(s.id)));
        const filtered = sup.split(',').map((x) => x.trim()).filter(Boolean).filter((id) => allowed.has(id));
        if (filtered.length === 0) {
          delete next.supplier;
          this.selectedSupplier = [];
        } else if (filtered.join(',') !== sup) {
          next.supplier = filtered.join(',');
          const keep = new Set(filtered);
          this.selectedSupplier = this.selectedSupplier.filter((id) => keep.has(String(id)));
        }
      }
    }

    // Пока грузятся поставщики, список клиентов ещё не перезагружен — пустой clients[] нельзя трактовать как «нет клиентов».
    const cl = this.formationQueryParamNorm(next.client);
    if (cl && !this.clientsIsLoading && !this.suppliersIsLoading) {
      if (cl === 'all') {
        if (!this.clients?.length) {
          delete next.client;
          this.selectedClient = [];
        }
      } else if (this.clients?.length) {
        const allowed = new Set(this.clients.map((c: { id: string | number }) => String(c.id)));
        const filtered = cl.split(',').map((x) => x.trim()).filter(Boolean).filter((id) => allowed.has(id));
        if (filtered.length === 0) {
          delete next.client;
          this.selectedClient = [];
        } else if (filtered.join(',') !== cl) {
          next.client = filtered.join(',');
          const keep = new Set(filtered);
          this.selectedClient = this.selectedClient.filter((id) => keep.has(String(id)));
        }
      }
    }
  }

  syncFormationQueryParams() {
    if (this.$route.name !== 'FormationOfAccountingSheets') {
      return;
    }
    if (this._formationSyncingFromRoute || this._formationSkipQuerySync || this._formationHydratingLists
      || this._formationSanitizingQuery) {
      return;
    }
    if (this.platformsIsLoading || !this.userPlatforms?.length) {
      return;
    }

    const next: Record<string, unknown> = { ...this.$route.query };

    if (this.dates?.length === 2) {
      next.dateFrom = this.dates[0];
      next.dateTo = this.dates[1];
    }

    if (this.hasSelectedPlatforms) {
      next.platform = this.getSelectedPlatformIds().join(',');
    } else {
      delete next.platform;
    }

    const sup = this.encodedSupplierQuery();
    const qSFromRoute = this.formationQueryParamNorm(this.$route.query.supplier);
    if (sup !== undefined) {
      next.supplier = sup;
    } else if (this.suppliersIsLoading && this.hasSelectedPlatforms && qSFromRoute) {
      next.supplier = qSFromRoute;
    } else if (qSFromRoute && this.hasSelectedPlatforms && (this.selectedSupplier?.length ?? 0) === 0) {
      if (this.suppliersIsLoading || (this.suppliers?.length ?? 0) === 0) {
        next.supplier = qSFromRoute;
      } else {
        delete next.supplier;
      }
    } else {
      delete next.supplier;
    }

    const cl = this.encodedClientQuery();
    const qCFromRoute = this.formationQueryParamNorm(this.$route.query.client);
    if (cl !== undefined) {
      next.client = cl;
    } else if (this.clientsIsLoading && this.hasSelectedPlatforms && qCFromRoute) {
      next.client = qCFromRoute;
    } else if (qCFromRoute && this.hasSelectedPlatforms && (this.selectedClient?.length ?? 0) === 0) {
      // Пока список клиентов пуст или ещё не подставили выбор из ссылки — не затирать client в URL
      if (this.clientsIsLoading || (this.clients?.length ?? 0) === 0) {
        next.client = qCFromRoute;
      } else {
        delete next.client;
      }
    } else {
      delete next.client;
    }

    this._formationSanitizingQuery = true;
    try {
      this.sanitizeFormationQueryParams(next);

      if (this.formationFilterQueryMatchesRoute(next)) {
        return;
      }

      this._formationSkipQuerySync = true;
      this.$router.replace({ query: next as Record<string, string | (string | null)[]> })
        .catch(() => undefined)
        .finally(() => {
          this.$nextTick(() => {
            this._formationSkipQuerySync = false;
          });
        });
    } finally {
      this._formationSanitizingQuery = false;
    }
  }

  applySuppliersAndClientsFromRoute() {
    const rawS = this.$route.query.supplier;
    const rawC = this.$route.query.client;

    if (rawS !== undefined && rawS !== null && String(rawS).length > 0) {
      const s = String(Array.isArray(rawS) ? rawS[0] : rawS).trim();
      if (s === 'all') {
        if (this.suppliers?.length) {
          this.selectedSupplier = this.suppliers.map((sup: { id: string | number }) => String(sup.id));
        }
      } else if (s) {
        const want = new Set(s.split(',').map((x) => x.trim()).filter(Boolean).map(String));
        this.selectedSupplier = this.suppliers
          .filter((sup: { id: string | number }) => want.has(String(sup.id)))
          .map((sup: { id: string | number }) => String(sup.id));
      }
    }

    if (rawC !== undefined && rawC !== null && String(rawC).length > 0) {
      const c = String(Array.isArray(rawC) ? rawC[0] : rawC).trim();
      if (c === 'all') {
        if (this.clients?.length) {
          this.selectedClient = this.clients.map((cl: { id: string | number }) => String(cl.id));
        }
      } else if (c) {
        const want = new Set(c.split(',').map((x) => x.trim()).filter(Boolean).map(String));
        this.selectedClient = this.clients
          .filter((cl: { id: string | number }) => want.has(String(cl.id)))
          .map((cl: { id: string | number }) => String(cl.id));
      }
    }
  }

  /** П. 6–7: кнопка всегда на экране; неактивна, если фильтры уже дефолтные и таблица не загружалась. */
  get resetFiltersDisabled(): boolean {
    if (this.isOperationsLoading) {
      return true;
    }
    if (this.filtersChanged()) {
      return false;
    }
    return !this.filtersWereApplied;
  }

  get showApplyFiltersHint(): boolean {
    return !this.filtersWereApplied && !this.groupOperationsByClients && !this.isOperationsLoading;
  }

  validateApplyFilters(): boolean {
    const datesOk = Array.isArray(this.dates) && this.dates.length === 2;
    const platformOk = this.hasSelectedPlatforms;
    const supplierOk = (this.selectedSupplier?.length ?? 0) > 0;
    const clientOk = (this.selectedClient?.length ?? 0) > 0;
    this.filterApplyErrors = {
      dates: !datesOk,
      platform: !platformOk,
      supplier: !supplierOk,
      client: !clientOk,
    };
    return datesOk && platformOk && supplierOk && clientOk;
  }

  async applyFilters() {
    if (this.isOperationsLoading) {
      return;
    }
    if (!this.validateApplyFilters()) {
      return;
    }
    this.stopAllFormationPolls();
    this.formationStatusByPlatform = {};
    this.filtersWereApplied = true;
    await this.loadOperations();
  }

  get listOfSuppliersFromOperations() {
    const result = uniqBy(this.operations, 'application.Supplier.id')
      .map((i: any) => ({
        id: i.application.Supplier.id,
        legal_name: i.application.Supplier.legal_name,
        total: 0,
      }));

    this.operations.forEach((operation: any) => {
      result.forEach((item: any) => {
        if (item.id === operation.application.Supplier.id) {
          item.total += operation.total;
        }
      });
    });

    return result;
  }

  get listOfClientsFromOperations() {
    const result = uniqBy(this.operations, 'application.client.id')
      .map((i: any) => ({
        id: i.application.client.id,
        legal_name: i.application.client.legal_name,
        total: 0,
      }));

    this.operations.forEach((operation: any) => {
      result.forEach((item: any) => {
        if (item.id === operation.application.client.id) {
          item.total += operation.total;
        }
      });
    });

    return result;
  }

  /** Formation alerts of the platform card: one per started process, or a single one when nothing started. */
  formationStatesForPlatform(platformId: string): FormationStatusState[] {
    return this.formationStatusByPlatform[platformId] ?? [];
  }

  /** The starter checks the screen against the work-calc mart, so a Talend screen goes the Talend way. */
  get formationUsesStarter(): boolean {
    return accountingSheetFormationUseStarter && accountingSheetCalculatedOperationsUseMart;
  }

  /**
   * True while the POST is in flight *or* any process it started is still running.
   *
   * The POST only hands jbpm a process id; the applications leave `supplier_confirmed_fact` some
   * 20–30 seconds later (measured on prod 04.08 across five sheets). Until then a second press
   * picks up the very same applications, so the button has to stay disabled for the whole run,
   * not just for the request. `failed`, `unknown` and `completed` re-enable it: a formation that did
   * not go through must be repeatable, and the starter refuses a supplier still being formed with `locked`.
   * The poll has no deadline, so a process that never reports back would keep the button disabled —
   * «Применить фильтры» clears `formationStatusByPlatform` and is the way out.
   */
  isPlatformForming(platformId: string): boolean {
    if (this.formingPlatformIds[platformId]) {
      return true;
    }

    return this.formationStatesForPlatform(platformId).some((state) => state.status === 'pending');
  }

  formationErrorText(state: FormationStatusState): string {
    return (state.error_details || state.error_trace || '')
      + (state.jbpmProcessId ? `\n\n${this.$t('formation_sheet_process_id', { id: state.jbpmProcessId })}` : '');
  }

  copyErrorText(state: FormationStatusState): void {
    navigator.clipboard.writeText(this.formationErrorText(state));
  }

  formationAlertType(state: FormationStatusState): string {
    if (state.status === 'failed') {
      return 'error';
    }
    if (state.status === 'unknown') {
      return 'warning';
    }
    if (state.status === 'completed') {
      return 'success';
    }
    return 'info';
  }

  formationSuccessText(state: FormationStatusState): string {
    const number = state.sheet_number || state.sheet_id;
    return this.$t('formation_sheet_success', { number: number ?? '—' }) as string;
  }

  setFormationState(platformId: string, index: number, patch: Partial<FormationStatusState>) {
    this.$set(
      this.formationStatusByPlatform,
      platformId,
      this.formationStatesForPlatform(platformId).map((state, i) => (i === index ? { ...state, ...patch } : state)),
    );
  }

  stopFormationPoll(platformId: string) {
    this.formationPollActive[platformId] = false;
    const timeoutId = this.formationPollTimeoutId[platformId];
    if (timeoutId !== undefined) {
      window.clearTimeout(timeoutId);
      delete this.formationPollTimeoutId[platformId];
    }
    const cancelSource = this.formationPollCancelSource[platformId];
    if (cancelSource) {
      cancelSource.cancel('formation poll stopped');
      this.formationPollCancelSource[platformId] = null;
    }
  }

  stopAllFormationPolls() {
    Object.keys(this.formationPollActive).forEach((platformId) => {
      this.stopFormationPoll(platformId);
    });
  }

  scheduleFormationPoll(platformId: string) {
    if (!this.formationPollActive[platformId]) {
      return;
    }
    const timeoutId = window.setTimeout(() => {
      this.pollFormationLap(platformId);
    }, FORMATION_POLL_INTERVAL_MS);
    this.formationPollTimeoutId[platformId] = timeoutId;
  }

  startFormationPoll(platformId: string) {
    this.stopFormationPoll(platformId);
    this.formationPollActive[platformId] = true;
    this.pollFormationLap(platformId);
  }

  /**
   * One lap over the platform's running processes, one request at a time, then 10 s to the next lap.
   * Not a timer per process: a platform forms up to 13 suppliers a month, and 13 requests every 10 s would
   * hold 13 of the gateway's 16 workers for the whole front, each one reading the jbpm database.
   */
  async pollFormationLap(platformId: string) {
    let completed = false;
    for (let index = 0; index < this.formationStatesForPlatform(platformId).length; index += 1) {
      const { status, jbpmProcessId } = this.formationStatesForPlatform(platformId)[index];
      if (status === 'pending' && jbpmProcessId) {
        // eslint-disable-next-line no-await-in-loop
        const outcome = await this.pollFormationProcess(platformId, index, jbpmProcessId);
        if (outcome === 'stopped') {
          return;
        }
        completed = completed || outcome === 'completed';
      }
    }
    if (completed) {
      // The reload after the POST runs while the mart still holds the pre-formation status, so it
      // redraws the very rows that were just consumed. By the time a process reports `completed`,
      // the connector has stamped them (work-calc /accounting-sheet/mark-formation-started), and this
      // is the first read that can actually show the supplier leaving the «Создать» list.
      // Not done on `failed`: a formation that did not go through must keep its operations offered.
      void this.loadOperations();
    }
    if (this.formationStatesForPlatform(platformId).some((state) => state.status === 'pending' && state.jbpmProcessId)) {
      this.scheduleFormationPoll(platformId);
    } else {
      this.stopFormationPoll(platformId);
    }
  }

  /** Polls one process into its alert; `stopped` — the poll was cancelled or the session is gone. */
  async pollFormationProcess(platformId: string, index: number, jbpmProcessId: string): Promise<'stopped' | 'completed' | 'polled'> {
    if (!this.formationPollActive[platformId]) {
      return 'stopped';
    }

    const cancelSource = Axios.CancelToken.source();
    this.formationPollCancelSource[platformId] = cancelSource;
    const fail = (i: number, errorCode: string, userHint: string, errorTrace: string) => this.setFormationState(platformId, i, {
      status: 'failed',
      error_code: errorCode,
      user_hint: userHint,
      error_trace: errorTrace,
      pollNetworkRetry: false,
    });

    try {
      const { data } = await Axios.get<FormationStatusApiResponse>(
        accountingSheet.formationStatus,
        {
          params: { jbpmProcessId },
          timeout: FORMATION_POLL_REQUEST_TIMEOUT_MS,
          cancelToken: cancelSource.token,
        },
      );
      this.setFormationState(platformId, index, {
        status: data.status,
        sheet_id: data.sheet_id ?? null,
        sheet_number: data.sheet_number ?? null,
        error_code: data.error_code ?? null,
        user_hint: data.user_hint ?? null,
        error_trace: data.error_trace ?? null,
        error_details: data.error_details ?? null,
        pollNetworkRetry: false,
      });
      return data.status === 'completed' ? 'completed' : 'polled';
    } catch (e) {
      if (Axios.isCancel(e)) {
        return 'stopped';
      }
      const axiosError = e as {
        response?: { status?: number; data?: unknown };
        message?: string;
      };
      const status = axiosError.response?.status;
      const responseData = axiosError.response?.data;
      const errorTrace = typeof responseData === 'string'
        ? responseData
        : JSON.stringify(responseData ?? axiosError.message ?? e, null, 2);

      const terminalApiError = isFormationPollTerminalApiError(status, responseData);
      if (terminalApiError === 'auth') {
        // The session is gone for every process of the platform, not just for this one.
        const authDenied = this.$t('formation_sheet_error_post_auth_denied') as string;
        this.formationStatesForPlatform(platformId).forEach((state, i) => {
          if (state.status === 'pending') {
            fail(i, 'POST_AUTH_DENIED', authDenied, errorTrace);
          }
        });
        this.stopFormationPoll(platformId);
        return 'stopped';
      }
      if (terminalApiError === 'status_api') {
        fail(index, 'FORMATION_STATUS_UNAVAILABLE', this.$t('formation_sheet_error_poll_status_unavailable') as string, errorTrace);
        return 'polled';
      }
      if (status === 403 || status === 404) {
        fail(index, 'PROCESS_NOT_FOUND', this.$t('formation_sheet_error_process_not_found', { id: jbpmProcessId }) as string, errorTrace);
        return 'polled';
      }

      this.setFormationState(platformId, index, { pollNetworkRetry: true });
      return 'polled';
    } finally {
      if (this.formationPollCancelSource[platformId] === cancelSource) {
        this.formationPollCancelSource[platformId] = null;
      }
    }
  }

  async toShape(platformId: string) {
    this.stopFormationPoll(platformId);
    const unsavedClients = clientsWithUnsavedRows(this.groupOperationsByClients, this.operations, platformId);
    if (unsavedClients.length) {
      // Formation takes the operations as stored: an edit left unsaved would silently miss the sheet.
      this.$set(this.formationStatusByPlatform, platformId, [{
        status: 'failed',
        error_code: 'UNSAVED_CHANGES',
        user_hint: this.$t('formation_sheet_unsaved_changes', { clients: unsavedClients.join(', ') }) as string,
      }]);
      return;
    }

    this.$set(this.formingPlatformIds, platformId, true);
    try {
      if (this.formationUsesStarter) {
        await this.startFormationWithStarter(platformId);
      } else {
        await this.startFormationWithTalend(platformId);
      }
    } finally {
      this.$delete(this.formingPlatformIds, platformId);
    }
  }

  async startFormationWithStarter(platformId: string) {
    const body = buildFormationStartBody(platformId, this.dates, this.selectedClient, this.operations);
    const t = (key: string) => this.$t(key) as string;
    let states: FormationStatusState[];
    try {
      const response = await Axios.post(accountingSheet.formationStart, body);
      states = formationStatesFromStartResponse(response.status, response.data, '', t);
    } catch (e) {
      const axiosError = e as {
        response?: { status?: number; data?: unknown };
        message?: string;
      };
      states = formationStatesFromStartResponse(
        axiosError.response?.status,
        axiosError.response?.data,
        String(axiosError.message ?? e),
        t,
      );
    }
    this.$set(this.formationStatusByPlatform, platformId, states);
    if (states.some((state) => state.status === 'pending')) {
      this.startFormationPoll(platformId);
      await this.loadOperations();
    }
  }

  async startFormationWithTalend(platformId: string) {
    const data = {
      dateFrom: this.dates[0],
      dateTo: this.dates[1],
      suppliers: this.listOfSuppliersFromOperationsForPlatform(platformId).map((i: any) => i.id),
      clients: this.listOfClientsFromOperationsForPlatform(platformId).map((i: any) => i.id),
      platformId,
    };
    try {
      const response = await Axios.post(accountingSheet.toShapeAccountingSheet, data);
      const jbpmProcessId = String(response.data?.result ?? '').trim();
      if (!jbpmProcessId) {
        this.$set(this.formationStatusByPlatform, platformId, [{
          status: 'failed',
          error_code: 'POST_INTERNAL_ERROR',
          user_hint: this.$t('formation_sheet_error_post_internal_error') as string,
          error_trace: JSON.stringify(response.data ?? null, null, 2),
        }]);
      } else {
        this.$set(this.formationStatusByPlatform, platformId, [{ status: 'pending', jbpmProcessId, pollNetworkRetry: false }]);
        this.startFormationPoll(platformId);
      }
      await this.loadOperations();
    } catch (e) {
      const parsed = parseAccountingSheetPostError(e, (key) => this.$t(key) as string);
      this.$set(this.formationStatusByPlatform, platformId, [{ status: 'failed', ...parsed, pollNetworkRetry: false }]);
    }
  }

  /** Two-decimal string for comparing sums / `actual_size` with PUT distribution. */
  formationDecimal2String(value: unknown): string {
    return decimal2(value);
  }

  /** Same rounding as displayed means (`meanQuality` / `meanPerformance`). */
  formationMeanFieldString(value: unknown): string {
    return this.formationDecimal2String(value);
  }

  /**
   * Parses `operation.total` from GET (Talend / mart) for aggregation.
   */
  formationParseStoredOperationTotal(op: any): number {
    const t = op?.total;
    const n = typeof t === 'number' ? t : parseFloat(String(t ?? '').replace(',', '.').replace(/\s/g, ''));
    return Number.isFinite(n) ? n : 0;
  }

  /**
   * Local `total` after bulk save without a new GET: `round(rate * value, 4)` where `value` is
   * `actual_work_time` for `work_billing_type.code === 'unproductive'`, else `actual_size`
   * (same value branch as work-calc mart spec / `Operation::addTotal`).
   * Talend `/operations/calculate` may differ slightly; `rate` is not refetched when only
   * quality/performance change — see `promts/formation-accounting-sheets-save-refresh-delta-plan.md`.
   */
  formationRecomputeOperationTotalLocal(op: any): number {
    const rate = parseFloat(String(op?.rate ?? '').replace(',', '.').replace(/\s/g, ''));
    const billing = op?.workType?.work_billing_type?.code;
    const value = billing === 'unproductive'
      ? Number(op?.actual_work_time ?? 0)
      : Number(op?.actual_size ?? 0);
    if (!Number.isFinite(rate)) {
      return this.formationParseStoredOperationTotal(op);
    }
    if (!Number.isFinite(value)) {
      return 0;
    }
    return Math.round(rate * value * 10000) / 10000;
  }

  /**
   * Re-aggregates `totalAmountNumeric` / `totalAmount` for one client panel from `this.operations`.
   */
  refreshFormationClientAggregatedTotals(clientKey: string) {
    const groupOperations = this.groupOperationsByClients?.[clientKey];
    if (!Array.isArray(groupOperations)) {
      return;
    }
    groupOperations.forEach((row: any) => {
      if (!row?.ids?.length) {
        return;
      }
      let sum = 0;
      row.ids.forEach((id: string | number) => {
        const op = this.operations.find((o: any) => String(o.id) === String(id));
        if (op) {
          sum += this.formationParseStoredOperationTotal(op);
        }
      });
      row.totalAmountNumeric = sum;
      row.totalAmount = this.$n(sum, 'decimal');
    });
  }

  /**
   * Per-id `actual_size` after group sum split (kopecks): share of each operation is proportional
   * to its `actual_work_time` (`workTimes`, same order as `ids`); a row without hours is split equally.
   * Truncated kopecks go one by one to the largest remainders, ties in `ids` order,
   * so the shares add up exactly to the entered sum.
   */
  formationDistributedActualSizeById(sumRaw: unknown, ids: (number | string)[], workTimes: unknown[] = []): Record<string, number> {
    const sumNum = Number(String(sumRaw).replace(',', '.'));
    const out: Record<string, number> = {};
    if (!ids.length || Number.isNaN(sumNum)) {
      return out;
    }
    // Integer arithmetic: kopecks × hundredths of an hour, exact remainders for ties.
    const hours = ids.map((_, i) => Math.max(Math.round((Number(workTimes[i]) || 0) * 100), 0));
    const hoursTotal = hours.reduce((acc, h) => acc + h, 0);
    const weights = hoursTotal > 0 ? hours : ids.map(() => 1);
    const weightTotal = hoursTotal > 0 ? hoursTotal : ids.length;
    const kopecks = Math.round(Math.abs(sumNum) * 100);
    const shares = weights.map((w, index) => {
      const scaled = kopecks * w;
      const rest = scaled % weightTotal;
      return { index, rest, kopecks: (scaled - rest) / weightTotal };
    });
    let missing = kopecks - shares.reduce((acc, s) => acc + s.kopecks, 0);
    [...shares].sort((a, b) => b.rest - a.rest || a.index - b.index).forEach((s) => {
      if (missing > 0) {
        s.kopecks += 1;
        missing -= 1;
      }
    });
    const sign = sumNum < 0 ? -1 : 1;
    shares.forEach((s) => {
      out[String(ids[s.index])] = (sign * s.kopecks) / 100;
    });
    return out;
  }

  syncFormationOperationRowAfterBulkSave(groupOperation: any, sent: { id: string | number; quality?: unknown; performance?: unknown; actual_size?: number }) {
    const idKey = String(sent.id);
    if (groupOperation.oldQualityById) {
      groupOperation.oldQualityById[idKey] = this.formationMeanFieldString(
        sent.quality !== undefined ? sent.quality : groupOperation.meanQuality,
      );
    }
    if (groupOperation.oldPerformanceById) {
      groupOperation.oldPerformanceById[idKey] = this.formationMeanFieldString(
        sent.performance !== undefined ? sent.performance : groupOperation.meanPerformance,
      );
    }
    if (sent.actual_size !== undefined && groupOperation.oldActualSizeById) {
      groupOperation.oldActualSizeById[idKey] = this.formationDecimal2String(sent.actual_size);
    }
    const raw = this.operations.find((o: any) => String(o.id) === idKey);
    if (raw) {
      if (sent.quality !== undefined) raw.quality = sent.quality;
      if (sent.performance !== undefined) raw.performance = sent.performance;
      if (sent.actual_size !== undefined) raw.actual_size = sent.actual_size;
      raw.total = this.formationRecomputeOperationTotalLocal(raw);
    }
  }

  formationWriteThroughIdempotencyKey(clientKey: string): string {
    const rand = Math.random().toString(36).slice(2, 10);
    return `formation-${clientKey}-${Date.now()}-${rand}`;
  }

  applyWriteThroughRows(updatedRows: any[]) {
    if (!Array.isArray(updatedRows) || updatedRows.length === 0) {
      return;
    }
    const byId = new Map(updatedRows.map((row: any) => [String(row?.id), row]));
    this.operations = this.operations.map((row: any) => byId.get(String(row?.id)) || row);
    this.groupOperationsByClients = this.groupingOfOperations(this.operations);
    if (this.groupOperationsByClients) {
      this.setOpenPanels(this.groupOperationsByClients);
    } else {
      this.openPanels = [];
    }
  }

  async saveQualityPerformance(key: string) {
    const groupOperations = this.groupOperationsByClients[key];
    if (groupOperations?.length && !this.isOperationsLoading) {
      this.isOperationsLoading = true;
      const operations: any[] = [];
      groupOperations.forEach((groupOperation: any) => {
        if (groupOperation?.ids?.length) {
          const sumNow = this.formationDecimal2String(groupOperation.sumActualSize);
          const sumBaseline = this.formationDecimal2String(groupOperation.oldSumActualSize);
          const volumeChanged = sumNow !== sumBaseline;

          if (volumeChanged) {
            const byId = this.formationDistributedActualSizeById(
              groupOperation.sumActualSize,
              groupOperation.ids,
              groupOperation.ids.map((id: number | string) => this.operations.find((o: any) => String(o.id) === String(id))?.actual_work_time),
            );
            groupOperation.ids.forEach((id: number | string) => {
              operations.push({
                id,
                quality: groupOperation.meanQuality,
                performance: groupOperation.meanPerformance,
                actual_size: byId[String(id)],
              });
            });
          } else {
            const qTarget = this.formationMeanFieldString(groupOperation.meanQuality);
            const pTarget = this.formationMeanFieldString(groupOperation.meanPerformance);
            groupOperation.ids.forEach((id: number | string) => {
              const idKey = String(id);
              const qOld = groupOperation.oldQualityById?.[idKey] ?? qTarget;
              const pOld = groupOperation.oldPerformanceById?.[idKey] ?? pTarget;
              if (qTarget !== qOld || pTarget !== pOld) {
                operations.push({
                  id,
                  quality: groupOperation.meanQuality,
                  performance: groupOperation.meanPerformance,
                });
              }
            });
          }
        }
      });
      try {
        if (!operations.length) {
          this.isOperationsLoading = false;
          this.$bus.$emit(
            'notification',
            this.$t('accounting_sheet_quality_performance_saved') as string,
            'success',
          );
          return;
        }
        if (accountingSheetWriteThroughUseWorkCalc) {
          const saveRes = await Axios.post(accountingSheet.bulkQualityPerformanceWorkCalc, {
            idempotency_key: this.formationWriteThroughIdempotencyKey(key),
            operations,
            context: {
              date_from: this.dates[0],
              date_to: this.dates[1],
              supplier_ids: this.selectedSupplier,
              client_ids: this.selectedClient,
              platform_ids: this.getSelectedPlatformIds(),
            },
          });
          const payload = saveRes?.data?.data || {};
          const status = String(payload?.status || '').toLowerCase();
          const msg = String(payload?.message || '');
          if (status === 'error') {
            throw new Error(msg || (this.$t('accounting_sheet_quality_performance_save_failed') as string));
          }
          const updatedRows = Array.isArray(payload?.operations) ? payload.operations : [];
          this.applyWriteThroughRows(updatedRows);
          this.isOperationsLoading = false;
          this.$bus.$emit(
            'notification',
            status === 'partial'
              ? (msg || 'Часть операций сохранена, проверьте статус строк')
              : (this.$t('accounting_sheet_quality_performance_saved') as string),
            status === 'partial' ? 'warning' : 'success',
          );
          return;
        }

        await Axios.put(accountingSheet.bulkQualityPerformance, { operations });
        operations.forEach((sent) => {
          const idKey = String(sent.id);
          const groupOperation = groupOperations.find((g: any) => g.ids?.some((x: string | number) => String(x) === idKey));
          if (groupOperation) {
            this.syncFormationOperationRowAfterBulkSave(groupOperation, sent);
          }
        });
        this.refreshFormationClientAggregatedTotals(key);
        groupOperations.forEach((groupOperation: any) => {
          if (groupOperation?.ids?.length) {
            groupOperation.oldSumActualSize = this.formationDecimal2String(groupOperation.sumActualSize);
            groupOperation.baselineMeanQuality = this.formationMeanFieldString(groupOperation.meanQuality);
            groupOperation.baselineMeanPerformance = this.formationMeanFieldString(groupOperation.meanPerformance);
          }
        });
        this.isOperationsLoading = false;
        this.$bus.$emit(
          'notification',
          this.$t('accounting_sheet_quality_performance_saved') as string,
          'success',
        );
      } catch (e) {
        console.error(e);
        this.isOperationsLoading = false;
        const err = e as {
          message?: string;
          response?: { data?: unknown };
        };
        let detail = '';
        const data = err.response?.data;
        if (typeof data === 'string') {
          detail = data;
        } else if (data && typeof data === 'object') {
          const o = data as Record<string, unknown>;
          if (o.message != null) detail = String(o.message);
          else if (o.error != null) detail = String(o.error);
        }
        const msg = detail || err.message
          || (this.$t('accounting_sheet_quality_performance_save_failed') as string);
        this.$bus.$emit('notification', msg, 'error');
      }
    }
  }

  clearReportFreshnessTicker() {
    if (this._reportFreshnessInterval != null) {
      window.clearInterval(this._reportFreshnessInterval);
      this._reportFreshnessInterval = null;
    }
  }

  resetReportFreshnessForLoad() {
    this.clearReportFreshnessTicker();
    this._reportFreshnessWatermark = '';
    this.reportFreshness = '';
  }

  armReportFreshnessAfterMartLoad(watermark: string) {
    this.clearReportFreshnessTicker();
    this._reportFreshnessWatermark = watermark;
    this.reportFreshness = formatReportFreshness(watermark);
    if (watermark && watermark !== '1970-01-01 00:00:00.000000') {
      this._reportFreshnessInterval = window.setInterval(() => {
        this.reportFreshness = formatReportFreshness(this._reportFreshnessWatermark);
      }, 1000);
    }
  }

  async loadOperations() {
    this.isOperationsLoading = true;
    this.resetReportFreshnessForLoad();
    try {
      if (accountingSheetCalculatedOperationsUseMart) {
        const params: Record<string, string> = {
          date_from: this.dates[0],
          date_to: this.dates[1],
          supplier: this.selectedSupplier.join(','),
          clientIds: this.selectedClient.join(','),
          statusCodes: ACCOUNTING_SHEET_CALC_DEFAULT_STATUS_CODES,
          stream: reportStream.mode,
        };
        const platformIds = this.getSelectedPlatformIds();
        if (platformIds.length) {
          params.platform_id = platformIds.join(',');
        }
        const res = await Axios.get(accountingSheet.calculatedOperationsMart, {
          params,
          responseType: 'json',
        });
        const parsed = parseReportResponse(res.data);
        const wm = (parsed.minProcessedAt || parsed.lastProcessedAt || '') as string;
        this.armReportFreshnessAfterMartLoad(wm);
        if (parsed.error) {
          this.$bus.$emit('notification', parsed.error, 'warning');
        }
        const ops = parsed.operations;
        if (ops?.length) {
          this.operations = ops;
          this.groupOperationsByClients = this.groupingOfOperations(this.operations);
          this.setOpenPanels(this.groupOperationsByClients);
        } else {
          this.groupOperationsByClients = null;
          this.operations = [];
        }
      } else {
        const platformIds = this.getSelectedPlatformIds();
        if (platformIds.length > 1) {
          this.$bus.$emit(
            'notification',
            'Несколько платформ поддерживаются только при загрузке расчёта из mart (work-calc). '
              + 'Выберите одну платформу или включите mart.',
            'warning',
          );
          this.groupOperationsByClients = null;
          this.operations = [];
          this.isOperationsLoading = false;
          return;
        }
        let url = accountingSheet.calculatedOperations;
        url = url.replace('{dateFrom}', this.dates[0]);
        url = url.replace('{dateTo}', this.dates[1]);
        url = url.replace('{supplier}', this.selectedSupplier.join(','));
        url = url.replace('{clientIds}', this.selectedClient.join(','));
        url = url.replace('{platformId}', platformIds[0] ?? '');
        const res = await Axios.get(url);
        if (res.data && res.data.length) {
          this.operations = res.data;
          this.groupOperationsByClients = this.groupingOfOperations(this.operations);
          this.setOpenPanels(this.groupOperationsByClients);
        } else {
          this.groupOperationsByClients = null;
          this.operations = [];
        }
      }
      this.isOperationsLoading = false;
    } catch (e) {
      console.error(e);
      this.resetReportFreshnessForLoad();
      this.isOperationsLoading = false;
      this.groupOperationsByClients = null;
      this.operations = [];
      this.$bus.$emit('notification', this.$t('accounting_sheet_operations_load_failed') as string, 'error');
    }
  }

  groupingOfOperations(items: any[]) {
    const groupByClients = groupBy(items, 'application.client.legal_name');
    Object.keys(groupByClients).forEach((client) => {
      const groupBySupplier = groupBy(groupByClients[client], 'application.Supplier.id');
      const array: any[] = [];
      Object.keys(groupBySupplier).forEach((supplierId) => {
        const groupByWorkTypeName = groupBy(groupBySupplier[supplierId], 'workType.id');
        Object.keys(groupByWorkTypeName).forEach((operationId) => {
          const opsForRow = groupByWorkTypeName[operationId];
          const oldQualityById: Record<string, string> = {};
          const oldPerformanceById: Record<string, string> = {};
          const oldActualSizeById: Record<string, string> = {};
          opsForRow.forEach((op: any) => {
            const idKey = String(op.id);
            oldQualityById[idKey] = this.formationMeanFieldString(op.quality);
            oldPerformanceById[idKey] = this.formationMeanFieldString(op.performance);
            oldActualSizeById[idKey] = this.formationDecimal2String(op.actual_size);
          });
          const meanPerformance = meanBy(opsForRow, 'performance').toFixed(2);
          const meanQuality = meanBy(opsForRow, 'quality').toFixed(2);
          const totalAmountNumeric = opsForRow.reduce(
            (acc, op) => acc + this.formationParseStoredOperationTotal(op),
            0,
          );
          array.push({
            ids: opsForRow.map((i) => i.id),
            supplierId,
            platformName: opsForRow[0]?.application?.platform?.name
              || opsForRow[0]?.application?.Platform?.name
              || '',
            supplierName: opsForRow[0]?.application?.Supplier?.legal_name || '',
            operationId,
            operationName: opsForRow[0]?.workType?.name || '',
            meanPerformance,
            meanQuality,
            baselineMeanPerformance: meanPerformance,
            baselineMeanQuality: meanQuality,
            sumActualSize: sumBy(opsForRow, 'actual_size').toFixed(2),
            oldSumActualSize: sumBy(opsForRow, 'actual_size').toFixed(2),
            oldQualityById,
            oldPerformanceById,
            oldActualSizeById,
            sumActualWorkTime: sumBy(opsForRow, 'actual_work_time'),
            performanceWatch: sumBy(opsForRow
              .filter((i) => i?.workType?.work_billing_type?.code === 'productive'), 'actual_work_time') || '',
            unproductiveWatch: sumBy(opsForRow
              .filter((i) => i?.workType?.work_billing_type?.code === 'unproductive'), 'actual_work_time') || '',
            costPerHour: opsForRow[0]?.workType?.work_billing_type?.code === 'unproductive'
              ? this.$n(opsForRow[0].rate, 'decimal') : '',
            boxCost: opsForRow[0]?.workType?.work_billing_type?.code === 'productive'
              ? this.$n(opsForRow[0].rate, 'decimal') : '',
            totalAmountNumeric,
            totalAmount: this.$n(totalAmountNumeric, 'decimal'),
            costCenter: opsForRow[0]?.workType?.cost_center?.name || '',
          });
        });
      });
      groupByClients[client] = array;
    });
    return groupByClients;
  }

  async beforeLoadSuppliers() {
    this._formationHydratingLists = true;
    this.selectedSupplier = [];
    this.selectedClient = [];
    await this.loadClients({ maxDepth: 1 });
  }

  async afterLoadSuppliers(_meta?: { platformSwitched?: boolean }) {
    this._formationHydratingLists = true;
    try {
      this.settingDefaultsInProgress = true;
      this.selectedSupplier = [];
      this.selectedClient = [];
      this.settingDefaultsInProgress = false;
      if (this.hasSelectedPlatforms) {
        await this.loadClients({ maxDepth: 1 });
        await this.$nextTick();
        if (!_meta?.platformSwitched) {
          this._formationSyncingFromRoute = true;
          try {
            this.applySuppliersAndClientsFromRoute();
          } finally {
            this._formationSyncingFromRoute = false;
          }
        }
      }
    } finally {
      this._formationHydratingLists = false;
    }
    if (_meta?.platformSwitched) {
      this.invalidateTableBecauseFiltersChanged();
    }
    this.$nextTick(() => this.syncFormationQueryParams());
  }

  async afterLoadingPlatforms() {
    if (!this.hasSelectedPlatforms) {
      return;
    }
    this.defaultSupplier = [];
    this.defaultClient = [];
  }

  setOpenPanels(object: any) {
    this.openPanels = Object.keys(object).map((k, i) => i);
  }

  sumTotalAmount(collection: any[]): number {
    return collection.reduce((sum, item) => {
      const n = item.totalAmountNumeric;
      if (typeof n === 'number' && Number.isFinite(n)) {
        return sum + n;
      }
      if (item.totalAmount == null || item.totalAmount === '') {
        return sum;
      }
      const parsed = parseFloat(String(item.totalAmount).replace(',', '.').replace(/\s/g, ''));
      return sum + (Number.isFinite(parsed) ? parsed : 0);
    }, 0);
  }

  @Watch('userPlatforms', { deep: true })
  formationUserPlatformsBecameAvailable() {
    const len = this.userPlatforms?.length ?? 0;
    if (len === 0) {
      this._lastUserPlatformsLen = 0;
      return;
    }
    if (this._lastUserPlatformsLen === 0) {
      this.initializePlatformFromUserAndStorage();
      this.$nextTick(() => this.syncFormationQueryParams());
    }
    this._lastUserPlatformsLen = len;
  }

  @Watch('selectedSupplier')
  selectedSupplierChanged() {
    this.setToStorage('suppliers', this.selectedSupplier.join(','));
    this.settingDefaultsInProgress = false;
    if (this.filterApplyErrors.supplier && (this.selectedSupplier?.length ?? 0) > 0) {
      this.filterApplyErrors = { ...this.filterApplyErrors, supplier: false };
    }
    if (this.shouldInvalidateTableBecauseUserChangedFilters()) {
      this.invalidateTableBecauseFiltersChanged();
    }
    if (!this._formationHydratingLists && !this._formationSanitizingQuery) {
      this.syncFormationQueryParams();
    }
  }

  @Watch('selectedClient')
  selectedClientChanged() {
    this.setToStorage('clients', this.selectedClient.join(','));
    this.settingDefaultsInProgress = false;
    if (this.filterApplyErrors.client && (this.selectedClient?.length ?? 0) > 0) {
      this.filterApplyErrors = { ...this.filterApplyErrors, client: false };
    }
    if (this.shouldInvalidateTableBecauseUserChangedFilters()) {
      this.invalidateTableBecauseFiltersChanged();
    }
    if (!this._formationHydratingLists && !this._formationSanitizingQuery) {
      this.syncFormationQueryParams();
    }
  }

  @Watch('selectedPlatform', { deep: true })
  formationPlatformQuerySync() {
    if (this.filterApplyErrors.platform && this.hasSelectedPlatforms) {
      this.filterApplyErrors = { ...this.filterApplyErrors, platform: false };
    }
    // Mixin `selectedPlatformChanged` returns before `afterLoadSuppliers` when no platforms — still clear stale table.
    if (!this.hasSelectedPlatforms && this.shouldInvalidateTableBecauseUserChangedFilters()) {
      this.invalidateTableBecauseFiltersChanged();
    }
    if (!this._formationHydratingLists) {
      this.$nextTick(() => this.syncFormationQueryParams());
    }
  }

  @Watch('dates', { deep: true })
  formationDatesQuerySync() {
    if (this.filterApplyErrors.dates && this.dates?.length === 2) {
      this.filterApplyErrors = { ...this.filterApplyErrors, dates: false };
    }
    if (this.shouldInvalidateTableBecauseUserChangedFilters()) {
      this.invalidateTableBecauseFiltersChanged();
    }
    this.syncFormationQueryParams();
  }

  formationPlatformSelectionKey(): string {
    return [...this.getSelectedPlatformIds()].sort().join(',');
  }

  defaultPlatformSelectionKey(): string {
    return [...(this.defaultPlatform || [])].map(String).sort().join(',');
  }

  filtersChanged(): boolean {
    return this.formationPlatformSelectionKey() !== this.defaultPlatformSelectionKey()
      || this.selectedSupplier.length !== this.defaultSupplier.length
      || this.selectedSupplier.some((supplerId, index) => supplerId !== this.defaultSupplier[index])
      || this.selectedClient.length !== this.defaultClient.length
      || this.selectedClient.some((clientId, index) => clientId !== this.defaultClient[index])
      || this.dates.length !== 2
      || this.dates[0] !== this.defaultDates[0]
      || this.dates[1] !== this.defaultDates[1];
  }

  /**
   * Таблица и сырые операции не соответствуют текущим фильтрам до повторного «Применить».
   * Не трогаем `isOperationsLoading`: при активном PUT фильтры в UI заблокированы; сброс мог бы расойтись с запросом.
   */
  invalidateTableBecauseFiltersChanged() {
    this.filtersWereApplied = false;
    this.groupOperationsByClients = null;
    this.operations = [];
    this.openPanels = [];
  }

  /** Смена фильтров из UI / логики страницы, не гидрация из query и не sanitize. */
  shouldInvalidateTableBecauseUserChangedFilters(): boolean {
    return !this._formationHydratingLists
      && !this._formationSyncingFromRoute
      && !this._formationSanitizingQuery;
  }

  clearFilters() {
    this.resetReportFreshnessForLoad();
    this.syncDefaultPlatformForFilters();
    this.calculateDefaultDates();
    this.dates = [...this.defaultDates];
    this.filterApplyErrors = {
      dates: false,
      platform: false,
      supplier: false,
      client: false,
    };
    this.filtersWereApplied = false;
    this.groupOperationsByClients = null;
    this.operations = [];
    // П. 8: одна платформа — остаётся выбранной; несколько — пусто (`defaultPlatform === []`).
    this.selectedPlatform = [...this.defaultPlatform];
    this.selectedSupplier = [];
    this.selectedClient = [];
    this.defaultSupplier = [];
    this.defaultClient = [];
    this.setToStorage('suppliers', '');
    this.setToStorage('clients', '');
    this.$bus.$emit('clear-filters');
    this.$nextTick(() => this.syncFormationQueryParams());
  }
}
